






































import {
    computed,
    defineComponent,
} from '@vue/composition-api';
import { SdsIcon } from '@superbet-group/web.lib.ui-components';
import { useLoginBeforeNavigate } from '@app/router/composables/useLoginBeforeNavigate';

export default defineComponent({
    name: 'HeaderLink',
    props: {
        name: {
            type: String,
            required: true,
        },
        tag: {
            type: String,
            required: false,
            default: '',
        },
        to: {
            type: [String, Object],
            required: true,
        },
        indicatorLabel: {
            type: [Number, String],
            required: false,
            default: 0,
        },
        isPage: {
            type: Boolean,
            required: false,
            default: false,
        },
        iconName: {
            type: String,
            required: true,
        },
        navigationContext: {
            type: String,
            required: true,
        },
        isLoginRequired: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    setup(props) {
        const { loginBeforeNavigate } = useLoginBeforeNavigate();

        const isNotificationsCounterVisible = computed<boolean>(() => !!props.indicatorLabel);

        return {
            isNotificationsCounterVisible,
            loginBeforeNavigate,
        };
    },
    components: {
        SdsIcon,
    },
});
